import type { ReceiptTemplate } from '../schema';

export const motel6Template: ReceiptTemplate = {
  id: 'motel-6',
  name: 'Motel 6 Receipt',
  brand: 'MOTEL 6',
  description: 'Motel 6 hotel receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'm6-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'MOTEL 6',
        businessNameFontSize: 22,
        addressLines: ['1200 DARK AVENUE', 'MONSTERVILLE, CA 94608', '(510) 555-0127'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'm6-guest',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'guest', label: 'Guest:', value: 'JOHN DOE' },
          { id: 'room', label: 'Room:', value: '108' },
        ],
        column2: [
          { id: 'in', label: 'Check-In:', value: '01/02/2026' },
          { id: 'out', label: 'Check-Out:', value: '01/04/2026' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'm6-charges',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'room', label: 'ROOM (2 NIGHTS)', value: '98.00', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX (12%)', value: '11.76', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '109.76', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'm6-payment',
      type: 'payment',
      enabled: true,
      config: { alignment: 'left', method: 'CASH', fields: [], showDivider: true, dividerStyle: 'dashed' },
    },
    {
      id: 'm6-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: "WE'LL LEAVE THE LIGHT ON\nFOR YOU\n\nTHANK YOU", fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: false },
    },
  ],
  updatedAt: new Date().toISOString(),
};

